import {Spinner} from 'components/template/Spinner'
import {useCallback, useEffect} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {AuthService} from 'rest'
import {toast} from 'react-hot-toast'

export const VerifyEmail = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const token = queryParams.get('token')

  const navigate = useNavigate()

  const verifyEmail = useCallback(async () => {
    const response = await AuthService.postApiAuthVerify({token})
    if (response.email_verified) {
      toast.success('Your email was verified successfully')
      if (user?.store) {
        navigate('/coupons')
      } else {
        navigate('/')
      }
    } else {
      toast.error('An error occurred/Link is expired')
      navigate('/')
    }
  }, [navigate, token, user?.store])

  useEffect(() => {
    if (token) {
      verifyEmail()
    } else {
      navigate('/')
    }
  }, [navigate, token, verifyEmail])

  return (
    <div className="text-gray-800 flex flex-col justify-center items-center h-screen w-full">
      <div className="h-6 w-6">
        <Spinner />
      </div>
    </div>
  )
}
